module.exports = __webpack_public_path__ + "img/playBtn.b4a20869.png";